'use strict';

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Status, fetchUpdatedFilterState, updatePostcode } from '../cfs-hub-slice';

import user from '../../../../profile/user';
import postcodeFormatting from '../../../../utils/postcode-formatting';

let LocationFilter = () => {
	const defaultValue = '2000';
	const dispatch = useDispatch();

	const distance = useSelector(state => state.cfsHubSearch.filterState.distance) ?? defaultValue;
	const postcode = useSelector(state => state.cfsHubSearch.location.postcode);
	const invalid = useSelector(state => state.cfsHubSearch.location.invalid);
	const filterStatus = useSelector((state) => state.cfsHubSearch.filterStatus);

	const [postcodeAltered, setPostcodeAltered] = useState(false);
	const [postcodeInvalid, setPostcodeInvalid] = useState(false);

	const onPostcodeChange = (e) => {
		const newPostcode = e.target.value;
		dispatch(updatePostcode(newPostcode));
		setPostcodeAltered(true);

		const isValid = postcodeFormatting.isValid(newPostcode);
		setPostcodeInvalid(!isValid);
	};

	const onPostcodeBlur = () => {
		if (postcodeAltered && !postcodeInvalid) {
			user.setPostcode(postcode);

			dispatch(fetchUpdatedFilterState({
				name: 'postcode',
				value: postcode
			}));
		}

		setPostcodeAltered(false);
	};

	const onPostcodeKeyPress = (e) => {
		if (filterStatus !== Status.Loading && (e.charCode === 13 || e.key === 'Enter')) {
			// enter key pressed
			e.preventDefault();
			e.stopPropagation();

			onPostcodeBlur();
		}
	};

	const onDistanceChange = (e) => {
		const value = e.target.value;

		dispatch(fetchUpdatedFilterState({
			name: 'distance',
			value: value
		}));
	}

	const filterClassName = invalid || (postcodeInvalid && !postcodeAltered)
		? 'cfs-hub-filters__location cfs-hub-filters__location--invalid'
		: 'cfs-hub-filters__location';

	const isPostcodeDisabled = filterStatus === Status.Uninitialised || filterStatus === Status.Loading;

	const postcodeValue = postcode;
	const postcodePlaceholder = 'Enter postcode...';

	const headingText = postcodeInvalid && !postcodeAltered
		? 'Postcode is invalid'
		: 'Postcode (required)';

	return (
		<div className={filterClassName}>
			<div className="cfs-hub-filters__filter cfs-hub-filters__location__postcode">
				<label className="cfs-hub-filters__location__postcode__label">{headingText}</label>
				<input className="cfs-hub-filters__filter__value cfs-hub-filters__location__postcode__value"
					type="text"
					placeholder={postcodePlaceholder}
					value={postcodeValue}
					onBlur={onPostcodeBlur}
					onKeyPress={onPostcodeKeyPress}
					onChange={onPostcodeChange}
					disabled={isPostcodeDisabled}
				/>
			</div>

			<div className="cfs-hub-filters__filter">
				<label>Distance</label>
				<select className="cfs-hub-filters__filter__value" value={distance} onChange={onDistanceChange}>
					<option key={defaultValue} value={defaultValue}>Any distance</option>
					<option key="1" value="1">Within 1 mile</option>
					<option key="5" value="5">Within 5 miles</option>
					<option key="10" value="10">Within 10 miles</option>
					<option key="20" value="20">Within 20 miles</option>
					<option key="30" value="30">Within 30 miles</option>
					<option key="40" value="40">Within 40 miles</option>
					<option key="60" value="60">Within 60 miles</option>
					<option key="100" value="100">Within 100 miles</option>
					<option key="200" value="200">Within 200 miles</option>
				</select>
			</div>
		</div>
	);
}

LocationFilter = React.memo(LocationFilter);

export { LocationFilter };